export const getDomainName = (hostName: string): string | number => {
    const domain = hostName.substring(
        hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1
    )
    return domain?.toLocaleLowerCase()?.slice(0, domain?.lastIndexOf('/'))
}
